<template>
	<div class="classificationBox">
		<el-button size="medium" type="primary" @click="adddialogVisible()">{{$t('QuesLibrary.Tambah')}}</el-button>

		<div style="margin: 20px 0px;">
			<span style="cursor: pointer;" :class="{ typeActive: tempPid == item.id ? 'typeActive' : '' }" v-for="item in options" :key="item.id" @click="queryData(item.id)">
				{{ item.questionnaireTypeName }}
			</span>
		</div>

		<el-table :data="tableData" border style="width: 100%">
			<el-table-column align="center" fixed prop="questionnaireTypeName" :label="$t('QuesLibrary.Name')"></el-table-column>
			<el-table-column align="center" prop="sortnum" :label="$t('QuesLibrary.SortOrder')"></el-table-column>
			<el-table-column align="center" fixed="right" :label="$t('QuesLibrary.Operate')" width="200">
				<template slot-scope="scope">
					<el-popconfirm :title="$t('QuesLibrary.AreYouSureToDeleteIt')" @confirm="delTempPaper(scope.row.id)">
						<el-link type="primary" :underline="false" slot="reference">{{$t('QuesLibrary.Delete')}}</el-link>
					</el-popconfirm>
					<el-link style="margin-left: 10px;" type="primary" :underline="false" @click="editTempPaper(scope.row)">{{$t('QuesLibrary.Edit')}}</el-link>
					<el-link style="margin-left: 10px;" type="primary" :underline="false" @click="sortTempPaper(scope.row)">{{$t('QuesLibrary.ModifySortingPosition')}}</el-link>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<el-input size="medium" v-model="tempPaperObj.title" :placeholder="$t('QuesLibrary.Name')" clearable :maxlength="50"></el-input>
				<el-select size="medium" style="width: 100%; margin: 20px 0px;" v-model="tempPaperObj.classification" :placeholder="$t('QuesLibrary.Category')" >
					<el-option v-for="item in options" :key="item.id" :label="item.questionnaireTypeName" :value="item.id"></el-option>
				</el-select>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="dialogOk()">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="title" :visible.sync="sortVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div><el-input-number controls-position="right" size="medium" v-model="sortNum" @change="handleChange" :min="0" :label="$t('QuesLibrary.SortPosition')"></el-input-number></div>

			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="sortVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="sortOk()">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sortId: '',
			sortNum: '',
			sortVisible: false,
			tempPaperObj: {
				title: '',
				classification: ''
			},
			addEditType: 1, //1添加 2编辑
			title: this.$t('QuesLibrary.Tambah'),
			dialogVisible: false,
			tableData: [],
			options: [],
			tempPid: ''
		};
	},
	created() {
		this.loadType();
	},
	methods: {
		sortOk() {
			let that = this;
			console.log(that.tempPaperObj);
			let questionnaireTypeIdQueries =  []
			let tempObj = {
				id: that.sortId,
				sortnum: that.sortNum 
			};
			questionnaireTypeIdQueries.push(tempObj);
			questionnaireTypeIdQueries=JSON.stringify(questionnaireTypeIdQueries)
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.questionnaireTypeSort}`,
				data:questionnaireTypeIdQueries,
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);

						that.loadData();
						that.sortVisible = false;
						that.sortNum = '';
						that.sortId = '';
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleChange(value) {
			console.log(value);
		},
		sortTempPaper(data) {
			console.log(data)
			this.sortId = data.id;
			this.sortNum = data.sortnum;
			this.sortVisible = true;
		},
		dialogOk() {
			if(this.tempPaperObj.title ==''){
				this.$message.warning(this.$t('QuesLibrary.PleaseEnterAName'));
				return false
			}
			if(this.tempPaperObj.classification ==''){
				this.$message.warning(this.$t('QuesLibrary.SelectCategory'));
				return false
			}
			let that = this;
			console.log(that.tempPaperObj);
			let url = '';
			let data = {
				questionnaireTypeName: that.tempPaperObj.title,
				pid: that.tempPaperObj.classification
			};
			if (this.addEditType == 2) {
				url = `${this.$config.service.questionnaireTypeUpdate}`;
				data.id = that.tempPaperObj.id;
			} else {
				url = `${this.$config.service.addQuestionTypes}`;
				delete data.id;
			}
			let params = {
				that: this,
				method: 'POST',
				url: url,
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);

						that.loadData();
						that.dialogVisible = false;
						that.tempPaperObj = {
							title: '',
							classification: ''
						};
						that.tempPaperObj.classification = ''
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		editTempPaper(data) {
			this.title = this.$t('QuesLibrary.Edit');
			this.addEditType = 2;
			this.dialogVisible = true;
			console.log(data);
			let tempPaperObj = JSON.parse(JSON.stringify(data));
			this.tempPaperObj = {
				title: tempPaperObj.questionnaireTypeName,
				classification: tempPaperObj.pid,
				id: tempPaperObj.id
			};
		},
		adddialogVisible() {
			this.title = this.$t('QuesLibrary.Tambah');
			this.addEditType = 1;
			this.dialogVisible = true;
			this.tempPaperObj = {
				title: '',
				classification: ''
			};
		},

		delTempPaper(id) {
			console.log(id);
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.delQuestionTypes}?id=${id}`,

				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						that.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleClose(done) {
			done();
		},
		queryData(pid) {
			this.tempPid = pid;
			this.loadData();
		},
		loadData() {
			let pid = this.tempPid;
			let that = this;
			let params = {
				that: this,
				method: 'GET',
				url: `${this.$config.service.tempPaperQuest}?pid=${pid}`,

				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.datas[0].questionnaireTypeList;
						// that.total = res.resultBody.total;
					} else {
						// that.tableData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadType() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryquestionnairetype,
				data: {},
				cb(res) {
					if (res.code == 0) {
						// requestUtil
						that.options = res.resultBody.datas;
						that.tempPid = that.options[0].id;
						that.loadData();
					} else {
						that.options = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.classificationBox {
	padding: 24px;
}
.typeActive {
	color: #0080ff;
}
</style>
